<template>
  <nav
    role="navigation"
    class="c-mobile-nav"
  >
    <button
      v-if="!navVisible"
      type="button"
      class="c-mobile-nav__burger"
      @click="showMenu"
    >
      <span>Menu</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="26px"
        height="21px"
        viewBox="0 0 26 21"
        version="1.1"
        aria-hidden="true"
      >

        <title>Show Menu</title>

        <g
          id="Navigation"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            id="M-Nav-Home"
            transform="translate(-19.000000, -62.000000)"
            fill="#022840"
            fill-rule="nonzero"
          >
            <g
              id="Header-Nav"
              transform="translate(0.000000, 44.000000)"
            >
              <g
                id="$ICON/Menu"
                transform="translate(19.000000, 18.000000)"
              >
                <g id="Shape">
                  <path d="M1.36842105,0 C0.612676316,0 0,0.606561095 0,1.35483827 C0,2.10311545 0.612676316,2.70967655 1.36842105,2.70967655 L24.6315789,2.70967655 C25.3873237,2.70967655 26,2.10311545 26,1.35483827 C26,0.606561095 25.3873237,0 24.6315789,0 L1.36842105,0 Z M1.36842105,9.14515834 C0.612676316,9.14515834 0,9.75172621 0,10.5000034 C0,11.2482806 0.612676316,11.8548417 1.36842105,11.8548417 L24.6315789,11.8548417 C25.3873237,11.8548417 26,11.2482806 26,10.5000034 C26,9.75172621 25.3873237,9.14515834 24.6315789,9.14515834 L1.36842105,9.14515834 Z M1.36842105,18.2903235 C0.612676316,18.2903235 0,18.8968845 0,19.6451617 C0,20.3934389 0.612676316,21 1.36842105,21 L24.6315789,21 C25.3873237,21 26,20.3934389 26,19.6451617 C26,18.8968845 25.3873237,18.2903235 24.6315789,18.2903235 L1.36842105,18.2903235 Z" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </button>
    <slot name="search" />
    <div
      class="c-mobile-nav__slide u-background-color-base j-mobile-nav__slide"
      :class="{'c-mobile-nav__slide--showing': navVisible}"
    >
      <nav-close-btn
        class="c-mobile-nav__close"
        @click="hideMenu"
      />
      <button
        class="c-mobile-nav__back t-heading-6"
        :class="[
          'l-flex',
          'l-flex--align-center',
          {'c-mobile-nav__back--showing': subNavVisible}
        ]"
        type="button"
        @click="closeSubMenus"
      >
        <svg
          width="8.414"
          height="14.828"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 11.414 20.828"
        >
          <title>Close Sub Menu</title>
          <path
            id="Icon_feather-chevron-left"
            data-name="Icon feather-chevron-left"
            d="M22.5,27l-9-9,9-9"
            transform="translate(-12.5 -7.586)"
            fill="none"
            stroke="#000"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="3"
          />
        </svg>
        Back
      </button>
      <div class="c-mobile-nav__container">
        <template v-for="(navItem, index) in navSections">
          <mobile-sub-nav
            :key="`m-${navItem.id}-${index}`"
            :nav-item="navItem"
            :is-mobile="isMobile"
            :my-index="index"
            :mobile-nav="false"
            :search-visible="searchVisible"
            :nav-visible="navVisible"
            :nav-item-visible="drawingMenus[navItem.id]"
            @hideSearch="hideSearch"
            @hideDrawingMenu="hideDrawingMenu"
            @showDrawingMenu="showDrawingMenu"
          />
        </template>
      </div>
      <template v-if="findYourRing">
        <nav-card
          v-if="!findYourRing.featured"
          :nav-item="findYourRing"
          :is-mobile="isMobile"
        />
        <nav-card-featured
          v-else
          :nav-item="findYourRing"
          :is-new="false"
        />
      </template>

      <mobile-utility-nav 
        :is-new="false"
      >
        <slot
          v-for="(_, name) in $slots"
          :slot="name"
          :name="name"
        />
      </mobile-utility-nav>
      <mobile-footer-nav
        :footer-nav="footerNav"
        :is-new="false"
      />
      <div
        v-if="$slots.footer"
        class="u-text-align-center"
      >
        <slot name="footer" />
      </div>
    </div>
  </nav>
</template>

<script>
import MobileSubNav from "./MobileSubNav.vue";
import NavCard from "../sharedComponents/NavCard.vue";
import NavCardFeatured from "../sharedComponents/NavCardFeatured.vue";
import MobileUtilityNav from "./MobileUtilityNav.vue";
import MobileFooterNav from "./MobileFooterNav.vue";
import NavCloseBtn from "../sharedComponents/NavCloseBtn.vue";
import NavMixin from '../NavMixin'

export default {
  name: "MobileNav",
  components: {
    MobileFooterNav,
    MobileUtilityNav,
    NavCard,
    NavCardFeatured,
    MobileSubNav,
    NavCloseBtn
  },
  mixins: [
    NavMixin,
  ],
  computed: {
    subNavVisible() {
      let result = 0
      for (let { open } of Object.values(this.drawingMenus)) {
        if (open) {
          result += 1
        }
      }
      return result > 0
    }
  },
  watch:{
    $route() {
      this.hideMenu();
    }
  },
  methods: {
    showMenu(){
      this.$emit('update:navVisible', true)
    },
    hideMenu(){
      this.$emit('update:navVisible', false)
    },
  }
}
</script>
<style lang="scss" scoped>
  .c-mobile-nav{
    &__slide{
      position: fixed;
      right: 103%;
      top: 0;
      opacity: 0;
      transition: right 0.3s, opacity 0.2s;
      width: 100%;
      height: 100%;
      overflow-y: auto;
      z-index: $zindex-global-header;
      padding: rem(20px) 0;

      &--showing{
        opacity: 1;
        right: 0;
      }
    }

    &__slide-new{
      position: fixed;
      right: 103%;
      top: 145px;
      opacity: 0;
      transition: right 0.3s, opacity 0.2s;
      width: 100%;
      height: calc(100% - 145px);
      overflow-y: auto;
      z-index: $zindex-global-header;

      &--showing{
        opacity: 1;
        right: 0;
      }
      @media screen and (max-width: 354px){
        top: 170px;
      }
      @media screen and (min-width: 437px) and (max-width: 706px){
        top: 145px;
      }
      @media screen and (min-width: 707px){
        top: 118px;
      }
    }

    &__burger{
      @include buttonReset;
      margin-right: rem(25px);

      path {
        @include themify($themes) {
          fill: themed('primary');
        }
      }
      span{
        position: absolute;
        clip: rect(1px, 1px, 1px, 1px);
        padding: 0;
        border: 0;
        height: 1px;
        width: 1px;
        overflow: hidden;
      }
    }

    &__close{
      @include buttonReset;
      position: absolute;
      right: rem(20px);
      @include themify($themes) {
        color: themed('primary');
      }
    }

    &__back{
      @include buttonReset;
      @include themify($themes) {
        background: themed('background', 'base');
      }
      position: fixed;
      left: 100%;
      top: 2px;
      opacity: 0;
      transition: left 0.3s, opacity 0.2s;
      padding: $filter-padding;
      text-align: left;
      cursor: pointer;

      &--showing{
        opacity: 1;
        left: 0;
      }

      svg{
        margin-right: rem(10px);
      }
    }
    &__container {
      margin-top: rem(40px);
    }

  }
</style>
